module.exports = __webpack_public_path__ + "img/mail.01ca5913.svg";